<template>
  <v-container fluid class="pt-0">

    <v-layout class="mb-2" row wrap align-content-space-between align-center>
      <v-flex grow>
        <div>
          <span>{{ new Date() | moment("dddd, MMMM D, YYYY") }}</span>
          <h1 class="hidden-xs-only">Welcome, {{ user.display_name }}!</h1>
        </div>
      </v-flex>
      <v-flex v-if="bulletins && bulletins.length > 0" grow>
        <div class="bulletin-board-title">
          <span>Bulletin Board</span>
        </div>
          <v-carousel
            hide-delimiters
            hide-controls
            height='100%'
          >
            <v-carousel-item
              v-for="(bulletin, i) in bulletins"
              :key="i"
            >
              {{ bulletin.message }}
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-flex>

      <v-flex shrink>
        <v-btn icon :to="{ name: 'myTodoList' }">
          <div v-if="overdueCount > 0">
            <v-badge
              color="red"
              right
              overlap
            >
              <template slot="badge">
                <span>{{ overdueCount }}</span>
              </template>
              <v-icon color="grey">check_circle_outline</v-icon>
            </v-badge>
          </div>
          <div v-else>
            <v-icon color="grey">check_circle_outline</v-icon>
          </div>
        </v-btn>
      </v-flex>

      <v-flex shrink>
        <v-btn :loading="gettingMail" icon to="/messages">
          <div v-if="unreadCount > 0">
            <v-badge
              color="red"
              right
              overlap
            >
              <template slot="badge">
                <span>{{ unreadCount }}</span>
              </template>
              <v-icon color="grey">mail_outline</v-icon>
            </v-badge>
          </div>
          <div v-else>
            <v-icon color="grey">mail_outline</v-icon>
          </div>
        </v-btn>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  created () {
    this.setUp()
  },
  computed: {
    ...mapState('menu', [
      // 'messages',
      'hasMail',
      'hasTasksDue'
    ]),
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('messages', [
      'unreadCount'
    ]),
    ...mapState('todos', [
      'overdueCount'
    ]),
  },
  methods: {
    setUp: function () {
      this.setOffMailChecker()
    }
  },
  data: function () {
    return {
      menuData: {},
      interval: null,
      gettingMail: false,
      bulletins: ["No messages"],
    }
  },
  methods: {
    setUp: function () {
      this.setOffMailChecker()
      this.getBulletinBoard()
      this.getOverdueTaskCount()
    },
    getOverdueTaskCount() {
      this.$store.dispatch('todos/getOverdueCount', this.user.id)
    },
    getBulletinBoard: function () {
      this.$store.dispatch('bulletinBoard/getForRole', { roleString: this.user.role })
      .then(bulletins => {
        this.bulletins = bulletins
      })
    },
    setOffMailChecker: function () {
      this.checkMail()
      let interval
      if (process.env.NODE_ENV == 'development') {
        interval = 600000 // wait longer in dev so we don't crowd server logs
      } else {
        interval = 600000
      }

      this.mailInterval = setInterval(function() {
        this.checkMail()
      }.bind(this), interval)
    },
    checkMail: function () {
      this.gettingMail = true
      this.$store.dispatch('messages/getUnreadCount')
      .then(res => {
        this.gettingMail = false
      })
      .catch(e => {
        console.log(e)
        this.gettingMail = false
      })
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  },
}
</script>

<style scoped>
  .bulletin-board-title span {
    padding-right: 5px;
    color: orange;
    font-weight: 800;
  }
  .v-carousel {
    box-shadow: none;
  }
</style>
